// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"57353f80","453":"c64a3e9e","457":"5e1c34b5","485":"19d9f8dd"}[chunkId] + ".chunk.js";
};